import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'



const http = axios.create({
    

  baseURL: process.env.NODE_ENV === 'production' ? `` : 'http://uxpenapi.cn',
  headers: {
    get: {
//       'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'

    },
    // 
    post: {
      // 'Content-Type': 'application/json;charset=utf-8'
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  },

})


http.interceptors.request.use(config=>{
  var token=localStorage.getItem("token")
 
  if(token){
    config.headers.Authorization= "Bearer "+token
  }
 
  return config;
})



export default http


// WEBPACK FOOTER //
// ./src/http.js